import { defineComponent as d, openBlock as o, createElementBlock as t, createBlock as p, withCtx as u, createTextVNode as c, toDisplayString as i, createCommentVNode as s, withDirectives as f, createElementVNode as V, mergeProps as N, isRef as h, vModelDynamic as k, unref as v, createVNode as y } from "vue";
import I from "../label/IstLabel.vue.mjs";
import g from "../icon/IstIcon.vue.mjs";
import { useVModel as M } from "../../node_modules/@vueuse/core/index.mjs";
const b = { class: "ist-input-container" }, B = ["id"], C = {
  key: 1,
  class: "ist-input-icon-container"
}, D = {
  key: 2,
  class: "ist-input-error-container"
}, S = /* @__PURE__ */ d({
  inheritAttrs: !1,
  __name: "IstInput",
  props: {
    modelValue: {},
    id: {},
    label: {},
    error: { type: Boolean },
    errorMessage: {},
    iconName: {}
  },
  emits: ["update:modelValue"],
  setup(a, { emit: l }) {
    const r = M(a, "modelValue", l, {
      passive: !0
    });
    return (e, n) => (o(), t("div", b, [
      e.label ? (o(), p(I, {
        key: 0,
        for: e.id
      }, {
        default: u(() => [
          c(i(e.label), 1)
        ]),
        _: 1
      }, 8, ["for"])) : s("", !0),
      f(V("input", N({
        id: e.id,
        "onUpdate:modelValue": n[0] || (n[0] = (m) => h(r) ? r.value = m : null),
        class: [{ error: e.error, hasIcon: !!e.iconName }]
      }, e.$attrs, { class: "ist-input" }), null, 16, B), [
        [k, v(r)]
      ]),
      e.iconName ? (o(), t("span", C, [
        y(g, { name: e.iconName }, null, 8, ["name"])
      ])) : s("", !0),
      e.error && e.errorMessage ? (o(), t("div", D, i(e.errorMessage), 1)) : s("", !0)
    ]));
  }
});
export {
  S as default
};
